import { I18n, TranslateOptions } from 'i18n-js';

import { en as enLocale } from 'app/locales/en';

const i18n = new I18n({ en: enLocale });
i18n.locale = 'en';

export const translate = (string: string, options?: TranslateOptions) => i18n.t(string, options);
